import { UserProfileJob, UserProfileRole } from './UserProfile'
import { UserGender } from './User'

export interface UserProfileDto {
  user: {
    _id: string
    updatedAt: string
    createdAt: string
    password: string
    firstname: string
    lastname: string
    gender: UserGender
    email: string
    nin: string
    roles: string[]
    __v: number
    activatedAt: string
    phone: string
  }
  profile: {
    _id: string
    roles: UserProfileRole[]
    email: string
    job: UserProfileJob
    organization: string
    createdBy: string
    user: string
    hash: string
    createdAt: string
    updatedAt: string
    __v: number
    disabledAt: string
  }
}

export const userProfileInit: UserProfileDto = {
  user: {
    _id: '',
    updatedAt: '',
    createdAt: '',
    password: '',
    firstname: '',
    lastname: '',
    gender: UserGender.Male,
    email: '',
    nin: '',
    roles: [],
    __v: 0,
    activatedAt: '',
    phone: '',
  },
  profile: {
    _id: '',
    roles: [],
    email: '',
    job: UserProfileJob.Seller,
    organization: '',
    createdBy: '',
    user: '',
    hash: '',
    createdAt: '',
    updatedAt: '',
    __v: 0,
    disabledAt: '',
  },
}
